import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const removeViewStmtInstruction = `
#### View removal
- Syntax: \`remove view <entity_name>;\`
- Example: \`remove view Products;\``;
export const stmtRemoveView = ({ viewName }) => {
    return `remove view ${viewName};`;
};
export const removeViewHandler = createStructureStatementHandler({
    type: 'remove view',
    parse: line => {
        const match = /^remove view (?<viewName>\w+)?/.exec(line);
        return match?.groups
            ? {
                type: 'remove view',
                viewName: match.groups.viewName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.removeView(stmt.viewName));
    },
});
//# sourceMappingURL=RemoveViewStmt.js.map